import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBrokerSelfRequestFormWidgetAdapterLoadable } from './NewbuildingBrokerSelfRequestFormWidgetAdapterLoadable';
import { selectNewbuildingBrokerSelfRequestFormWidgetActive } from 'shared/selectors/newbuildingBrokerSelfRequestFormWidget';

export const NewbuildingBrokerSelfRequestFormWidgetContainer: React.FC = () => {
  const active = useSelector(selectNewbuildingBrokerSelfRequestFormWidgetActive);

  if (!active) {
    return null;
  }

  return <NewbuildingBrokerSelfRequestFormWidgetAdapterLoadable />;
};
